export const JobPriority = {
    Normal: null,
    Red: "1",
    Blue: "2",
    Green: "3",
} as const;

export type JobPriority = (typeof JobPriority)[keyof typeof JobPriority];
